function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "folder-music");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.405 2.799c-0.112-0.44-0.656-0.799-1.21-0.799h-14.39c-0.555 0-1.099 0.359-1.21 0.799l-0.201 1.201h17.211l-0.2-1.201zM19.412 5h-18.825c-0.342 0-0.609 0.294-0.577 0.635l0.923 11.669c0.038 0.394 0.37 0.696 0.766 0.696h16.601c0.397 0 0.728-0.302 0.766-0.696l0.923-11.669c0.033-0.341-0.235-0.635-0.577-0.635zM11.942 12.521c-0.128 0.265-0.258 0.279-0.202 0 0.146-0.721 0.047-2.269-1.043-2.441v3.294c0 0.674-0.311 1.262-1.136 1.528-0.802 0.256-1.699-0.011-1.908-0.586s0.261-1.276 1.052-1.564c0.442-0.161 0.954-0.203 1.299-0.070v-4.682h0.694c-0.001 1.633 2.818 1.275 1.244 4.521z"
});

var SvgFolderMusic = function SvgFolderMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-music.8533c207.svg";
export { ForwardRef as ReactComponent };